export const getUrl = (brand: string | null) => {
    let firstUpper = brand;

    if (typeof brand?.charAt(0) === 'string') {
        firstUpper = brand.charAt(0).toUpperCase() + brand.slice(1);
    }

    if (firstUpper === 'Magnum') {
        firstUpper = firstUpper + 'm';
    }

    if (firstUpper?.includes(' ')) {
        const [firstPart, secondPart] = firstUpper?.split(' ');
        firstUpper =
            firstPart.charAt(0).toUpperCase() +
            firstPart.slice(1) +
            '-' +
            secondPart.charAt(0).toLowerCase() +
            secondPart.slice(1);
    }

    return firstUpper + '.png';
};
